var exports = {
  "P": "x2b2fbebb--1b3b8b--label",
  "D": "x2b2fbebb--1b3b8b--title",
};

module.exports = exports;
